import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const TermsOfServicePage = () => {
  useEffect(() => {
    document.title = 'Terms of Service - Tanzania Basketball Federation';
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <header className="w-full py-6 px-4 lg:px-6 border-b border-border bg-card">
        <div className="max-w-3xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
              <Icon name="FileText" size={20} color="white" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-foreground">Terms of Service</h1>
              <p className="text-xs text-muted-foreground">Tanzania Basketball Federation</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" iconName="ArrowLeft" asChild>
            <Link to="/login">Back to Login</Link>
          </Button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-10 space-y-6">
        <div className="bg-card rounded-lg border border-border card-shadow p-6 md:p-8 space-y-5">
          <p className="text-sm text-muted-foreground">
            Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">Appropriate Use of the System</h2>
            <p className="text-foreground leading-relaxed">
              The Tanzania Basketball Federation (TBF) Registration System is provided solely for the
              purpose of centralising data for basketball development and administration within
              Tanzania. By using this system, you agree to use it only for authorised basketball
              management activities and in a manner consistent with TBF policies and applicable law.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground">Permitted Purpose</h2>
            <p className="text-foreground leading-relaxed">
              Permitted use includes registration and management of players, teams, officials,
              leagues, tournaments, and related administrative records that support the organisation,
              growth, and governance of basketball in Tanzania under TBF.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground">Prohibited Conduct</h2>
            <ul className="list-disc pl-5 space-y-2 text-foreground">
              <li>
                Using the system for any purpose unrelated to basketball development or administration
                in Tanzania.
              </li>
              <li>
                Attempting to access accounts, records, or functions for which you are not authorised.
              </li>
              <li>
                Tampering with, falsifying, deleting, or misusing data held in the system.
              </li>
              <li>
                Sharing credentials, scraping data without authorisation, or disrupting system
                availability or security.
              </li>
              <li>
                Using the platform for commercial, political, or personal activities outside TBF’s
                mandate.
              </li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground">Account Responsibility</h2>
            <p className="text-foreground leading-relaxed">
              You are responsible for all activity carried out under your account. You must maintain
              the confidentiality of your credentials and immediately notify TBF if you suspect
              unauthorised use.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground">Enforcement</h2>
            <p className="text-foreground leading-relaxed">
              TBF may suspend or revoke access, require corrective action, or pursue other remedies
              where these Terms of Service are breached. Continued use of the system constitutes
              acceptance of these terms.
            </p>
          </section>
        </div>
      </main>

      <footer className="w-full py-6 px-4 border-t border-border">
        <p className="text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} Tanzania Basketball Federation. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default TermsOfServicePage;
